export function getQuotationTypes() {
    return axios({
        url: `/api/quotations`,
        method: 'get',
    });
}

export function getQuotation(id, productCode) {
  return axios({
    url: `/api/quotations/${id}?code=${productCode}`,
    method: 'get',
  });
}

export function fetchQuotationRequests(params) {
  return axios({
    url: `/api/quotation-requests`,
    method: 'get',
    params: params,
  });
}

export function getQuotationRequest(id) {
  return axios({
    url: `/api/quotation-requests/${id}`,
    method: 'get',
  });
}

export function createQuotationRequest(data) {
  const formData = new FormData();
  const { values, files, keepFiles, ...dataWithoutValues  } = data;

  Object.keys(dataWithoutValues).forEach(key => {
    let value = dataWithoutValues[key];

    if (key === 'is_draft') value = value ? 1 : 0;

    if (value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });

  if (data.company && Array.isArray(data.company)) {
    data.company.forEach(name => {
      formData.append('company[]', name);
    });
  }

  Object.keys(data.values).forEach(fieldId => {
    const value = data.values[fieldId];

    if (value !== null && value !== undefined) {
      formData.append(`values[${fieldId}]`, value ?? '')
    }
    // if (value instanceof File) {
    //   formData.append(`values[${fieldId}]`, value, value.name)
    // } else if (value !== null && value !== undefined) {
    //   formData.append(`values[${fieldId}]`, value ?? '')
    // }
  });
  // files
  Object.keys(data.files).forEach(fieldId => {
    const file = data.files[fieldId]
    formData.append(`files[${fieldId}]`, file, file.name)
  })
  // keep files
  data.keepFiles.forEach(fieldId => {
    formData.append(`keep_files[]`, fieldId)
  })

  return axios.post('/api/quotation-requests', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function updateQuotationRequest(id, data) {

  const formData = new FormData();
  const { values, ...dataWithoutValues  } = data;

  Object.keys(dataWithoutValues).forEach(key => {
    let value = dataWithoutValues[key];
    if (key === 'is_draft') value = value ? 1 : 0;
    if (value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });

  Object.keys(data.values).forEach(fieldId => {
    const value = data.values[fieldId]
    if (value instanceof File) {
      formData.append(`values[${fieldId}]`, value, value.name)
    } else if (value !== null && value !== undefined) {
      formData.append(`values[${fieldId}]`, value ?? '')
    }
  });

//  formData.append('_method', 'PUT')

  return axios.post(`/api/quotation-requests/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function getQuotationMessages(id) {
  return axios({
    url: `/api/quotation-requests/${id}/messages`,
    method: 'get',
  });
}

export function sendQuotationMessages(id, formData) {
  return axios({
    url: `/api/quotation-requests/${id}/messages`,
    method: 'post',
    data: formData,
  });
}

export function readQuotationMessages(id, data) {
  return axios({
    url: `/api/quotation-requests/${id}/messages/read`,
    method: 'post',
    data: data,
  });
}

/**
 *
 * @returns {AxiosPromise}
 * @param requestId
 */
export function getPropositionsByRequest(requestId) {
  return axios({
    url: `/api/quotation-propositions/by-request/${requestId}`,
    method: 'get',
  });
}

export function selectProposition(id) {
  return axios({
    url: `/api/quotation-propositions/${id}`,
    method: 'put',
  });
}
